"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getDisabledOk({ hasError, isLoading, dirty }) {
    if (isLoading) {
        return true;
    }
    else if (!dirty) {
        return false;
    }
    else {
        return hasError;
    }
}
exports.default = getDisabledOk;
//# sourceMappingURL=getDisabledOk.js.map